import { IBerater } from '../model/berater-http.model';
import { FilterOption } from '@shared-ikp/model/filter-options.model';
import { AccountStatus } from '../model/account-status.model';

export type BeraterTransformerKeys = keyof typeof beraterDropdownTypeMapping;
export type BeraterSupportedDropdownTypes = Parameters<(typeof beraterDropdownTypeMapping)[BeraterTransformerKeys]>[0];
export type BeraterReturnTypeMap = { [K in BeraterTransformerKeys]: ReturnType<(typeof beraterDropdownTypeMapping)[K]>[number] };

export function IBeraterArrayTransformer(value: IBerater[]): FilterOption<IBerater>[] {
  if (!value) {
    return [];
  }
  return value
    .sort((a, b) => {
      const firstNameCompare = a.firstName.localeCompare(b.firstName);
      return firstNameCompare !== 0 ? firstNameCompare : a.lastName.localeCompare(b.lastName);
    })
    .map(b => ({
      text: b.firstName + ' ' + b.lastName,
      value: b,
    }));
}

export function AssignedIBeraterArrayTransformer(value: IBerater[]): FilterOption<IBerater>[] {
  const options = IBeraterArrayTransformer(value);

  return [
    {
      text: 'home.berater.notAssigned',
      value: {
        id: 'none',
        firstName: '',
        lastName: '',
        email: '',
      },
    },
    ...options,
  ];
}

function AccountStatusEnumTransformer(value: typeof AccountStatus | (typeof AccountStatus)[]): FilterOption<AccountStatus>[] {
  const enums = Array.isArray(value) ? value : [value];
  const allValues = enums.flatMap(enumObj => Object.values(enumObj));
  return allValues.map(status => ({
    text: status,
    value: status as AccountStatus,
  }));
}

export const beraterDropdownTypeMapping = {
  BeraterArray: IBeraterArrayTransformer,
  AssignedBeraterArray: AssignedIBeraterArrayTransformer,
  AccountStatus: AccountStatusEnumTransformer,
};
